module.exports = __webpack_public_path__ + "img/EXTERIOR-JIMNY-5.b9dad135.jpg";